import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { loadTicketsDoo } from "../../redux/tasks/ticketsT";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import ParamGraph from "../../components/ParamGraph";

const DashboardDOO = ({ loading, tickets, role, loadTicketsDoo }) => {
  useEffect(() => {
    loadTicketsDoo();
  }, [loadTicketsDoo]);
  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="flex flex-col h-screen">
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 p-4 overflow-y-auto">
            <div className="flex flex-col w-full justify-center items-center my-10">
              <h1 className="text-3xl font-bold text-neutral-800 my-5">
                Dashboard
              </h1>
              <h1 className=" text-xl font-semibold text-neutral-700 my-3">
                Below is the graph for all the tickets regarding your region.
              </h1>
              {tickets?.length > 0 ? (
                <ParamGraph tickets={tickets} role={role} filters={true} />
              ) : (
                <h1>No Tickets available</h1>
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

DashboardDOO.proopTypes = {
  loading: PropTypes.bool.isRequired,
  tickets: PropTypes.array,
  role: PropTypes.string,
  loadTicketsDoo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.tickets.loading,
  tickets: state.tickets.tickets,
  role: state.auth.user.role,
});

export default connect(mapStateToProps, { loadTicketsDoo })(DashboardDOO);
